import * as firebase from "firebase/app";
import { isMobile } from "react-device-detect";
import {
  fetchAndActivate,
  getRemoteConfig,
  getString
} from "firebase/remote-config";
import { getAnalytics, setUserProperties } from "firebase/analytics";
import {
  REQUEST_TIMEOUT,
  FIREBASE_CACHE_TIMEOUT,
  REACT_APP_ENV,
  IS_ENV
} from "@util/config";
import { DeviceType, Media, FirebaseResult } from "@type/index";
import { isApp } from "@util/common";
import store from "../../redux/store";

const firebaseConfig = (brand: string, country: string) => ({
  apiKey: IS_ENV(brand, country).firebaseApiKey,
  projectId: IS_ENV(brand, country).firebaseProjectId,
  appId: IS_ENV(brand, country).firebaseAppId,
  measurementId: IS_ENV(brand, country).firebaseMeasurementId
});
let firebaseApp: firebase.FirebaseApp;

if (firebase.getApps().length === 0) {
  const { region, language, brand_name } = store.getState().app;
  firebaseApp = firebase.initializeApp(firebaseConfig(brand_name, region));
  const analytics = getAnalytics();
  setUserProperties(analytics, {
    language, // jp, us, ca
    platform: isApp() ? Media.APP : Media.WEB, // "app" or "web"
    device: isMobile ? DeviceType.SP : DeviceType.PC, // "sp" or "pc"
    environment: REACT_APP_ENV
  });
  if (
    !IS_ENV(brand_name, region).firebaseApiKey ||
    !IS_ENV(brand_name, region).firebaseProjectId ||
    !IS_ENV(brand_name, region).firebaseAppId
  ) {
    window.console.warn(
      "missing firebase env. Config the '.env' file and rebuild the project."
    );
  }
}

export const getVisualSearchMinScoreConfig = () =>
  new Promise<null | FirebaseResult>((resolve) => {
    try {
      const remoteConfig = getRemoteConfig(firebaseApp);
      setTimeout(() => {
        resolve(null);
      }, REQUEST_TIMEOUT);
      remoteConfig.settings.minimumFetchIntervalMillis = FIREBASE_CACHE_TIMEOUT;
      // " fetchTimeoutMillis" doesn't work
      // remoteConfig.settings.fetchTimeoutMillis = REQUEST_TIMEOUT;
      fetchAndActivate(remoteConfig)
        .then(() => {
          resolve({
            minScore: getString(
              remoteConfig,
              "imagesearch_item_matching_min_score"
            ),
            imagesearch_wish: getString(remoteConfig, "imagesearch_wish")
          });
        })
        .catch(() => {
          resolve(null);
        });
    } catch (e) {
      window.console.log(e);
      resolve(null);
    }
  });
